/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const identify = (userId: string) => {
  if (userId) {
    if (window.dataLayer) {
      window.dataLayer.push({
        // @ts-expect-error
        event: 'mixpanelIdentify',
        mixpanelPayload: userId,
      })
    } else {
      window.mixpanel?.identify?.(userId)
    }
  }
}
